import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "app",
  initialState: {
    initials: {
      enums: {},
    },
    rowsPerPage: 10,
    imageViewerUrl: undefined,
  },
  reducers: {
    setInitials(state, { payload }) {
      state.initials = payload;
    },
    setRowsPerPage(state, { payload }) {
      state.rowsPerPage = payload;
    },
    openImage(state, { payload }) {
      state.imageViewerUrl = payload;
    },
    closeImage(state) {
      state.imageViewerUrl = undefined;
    },
  },
});

export const { setInitials, setRowsPerPage, openImage, closeImage } =
  appSlice.actions;
export default appSlice.reducer;
